import Extractor from './extractor.js';

class Twitter extends Extractor{

  extract(item){
    const result = super.extract(item);
    const data = item.pagemap;

    result['reviewcount'] = this.getData(
      [
        {instance: data, object:'aggregaterating', property: 'reviewcount'},        
      ], null);

    result['ratingcount'] = this.getData(
      [
        {instance: data, object:'aggregaterating', property: 'ratingcount'},        
      ], null);

    result['best'] = this.getData(
      [
        {instance: data, object:'aggregaterating', property: 'bestrating'},        
        {instance: data, object:'rating', property: 'bestrating'},        
      ], null);

    result['worst'] = this.getData(
      [
        {instance: data, object:'rating', property: 'worstrating'},        
      ], null);

    result['rating'] = this.getData(
      [
        {instance: data, object:'aggregaterating', property: 'ratingvalue'},        
        {instance: data, object:'rating', property: 'ratingvalue'},        
      ], null);

    result['has_data'] = (result['rating'] !== null || result['ratingcount'] !== null) ? 1 : 0;

    return result;
  }
}

export default (Twitter);


// WEBPACK FOOTER //
// ./src/search/extractor/rating.js